import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import { Checkbox, Divider, Form, Popconfirm, Space, Tooltip } from "antd";
import { useFormSettings, useI18n } from "../../../contexts";
import { WarningOutlined } from "@ant-design/icons";
const FormSettingsResetTabContent = ()=>{
    const { __ } = useI18n();
    const { onResetAll, onResetTexts, resetTextsLanguages } = useFormSettings();
    const [resetConsents, setResetConsents] = useState(false);
    const defaultChecked = useMemo(()=>resetTextsLanguages.filter((item)=>item.isRequired).map((item)=>item.code), [
        resetTextsLanguages
    ]);
    const [resetTextsLanguagesChecked, setResetTextsLanguagesChecked] = useState(defaultChecked);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Form.Item, {
                label: __("Reset texts"),
                children: [
                    /*#__PURE__*/ _jsxs("p", {
                        className: "description",
                        style: {
                            marginTop: 6
                        },
                        children: [
                            __("You can reset all texts in your cookie banner to their default values. This includes texts in the customizer (customize banner), service groups, services (if created from the service template), content blockers (if created from the content blocker template) and the cookie policy (if created)."),
                            resetTextsLanguages.length > 1 && /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    "\xa0",
                                    __("You can select multiple languages for which you want to reset the texts.")
                                ]
                            })
                        ]
                    }),
                    resetTextsLanguages.length !== 1 && /*#__PURE__*/ _jsxs(Space, {
                        direction: "vertical",
                        children: [
                            /*#__PURE__*/ _jsxs(Space, {
                                direction: "horizontal",
                                children: [
                                    /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        onClick: (e)=>{
                                            e.preventDefault();
                                            setResetTextsLanguagesChecked(resetTextsLanguages.map((item)=>item.code));
                                        },
                                        children: __("Select all")
                                    }),
                                    /*#__PURE__*/ _jsx(Divider, {
                                        type: "vertical"
                                    }),
                                    /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        onClick: (e)=>{
                                            e.preventDefault();
                                            setResetTextsLanguagesChecked(defaultChecked);
                                        },
                                        children: __("Deselect all")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Checkbox.Group, {
                                options: resetTextsLanguages.map((param)=>{
                                    let { code, name, isDisabled, isRequired, notice } = param;
                                    return {
                                        label: notice ? /*#__PURE__*/ _jsxs(Tooltip, {
                                            title: notice,
                                            children: [
                                                name,
                                                "\xa0",
                                                /*#__PURE__*/ _jsx(WarningOutlined, {})
                                            ]
                                        }) : name,
                                        value: code,
                                        disabled: isDisabled || isRequired
                                    };
                                }),
                                value: resetTextsLanguagesChecked,
                                onChange: (value)=>setResetTextsLanguagesChecked(value)
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        style: {
                            marginTop: 10
                        },
                        children: /*#__PURE__*/ _jsx(Popconfirm, {
                            title: __("Are you sure?"),
                            cancelText: __("Cancel"),
                            okText: __("Reset texts"),
                            onConfirm: ()=>onResetTexts(resetTextsLanguagesChecked),
                            placement: "topLeft",
                            children: /*#__PURE__*/ _jsx("input", {
                                type: "button",
                                className: "button",
                                value: __("Reset")
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Form.Item, {
                label: __("Reset all"),
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "description",
                        style: {
                            marginTop: 6
                        },
                        children: __("You can reset all settings of Real Cookie Banner to the default values. This will also irreversibly delete any services and content blockers that have been created, as well as design settings. Documentation of consent may be kept to fulfill the legal disclosure requirement.")
                    }),
                    /*#__PURE__*/ _jsx(Checkbox, {
                        checked: resetConsents,
                        onChange: (e)=>setResetConsents(e.target.checked),
                        children: __("Delete documented consent")
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        style: {
                            marginTop: 10
                        },
                        children: /*#__PURE__*/ _jsx(Popconfirm, {
                            title: __("Are you sure?"),
                            cancelText: __("Cancel"),
                            okText: __("Reset all"),
                            onOpenChange: (open)=>!open && setResetConsents(false),
                            onConfirm: ()=>onResetAll(resetConsents),
                            placement: "topLeft",
                            children: /*#__PURE__*/ _jsx("input", {
                                type: "button",
                                className: "button",
                                value: __("Reset")
                            })
                        })
                    })
                ]
            })
        ]
    });
};
export { FormSettingsResetTabContent };
